<template>
    <div>  
        <div v-if="(value==='DEBUG')" class='log-level-debug'><i class='fa fa-circle'/>&nbsp;{{value}}</div>
        <div v-else-if="(value==='ERROR')" class='log-level-error'><i class='fa fa-times-circle'/>&nbsp;{{value}}</div>
        <div v-else-if="(value==='FATAL')" class='log-level-fatal'><i class='fa fa-exclamation-circle'/>&nbsp;{{value}}</div>
        <div v-else-if="(value==='WARN')" class='log-level-warn'><i class='fa fa-warning'/>&nbsp;{{value}}</div>
        <div v-else-if="(value==='SECURITY')" class='log-level-security'><i class='fa fa-key'/>&nbsp;{{value}}</div>
        <div v-else class='log-level-info'><i class='fa fa-info-circle'/>&nbsp;{{value}}</div>
    </div>
</template>
<script>
export default {
  props: ["value"]  
  };
</script>
<style scoped>
.log-level-debug {
  color: blue;
}
.log-level-error {
  color: red;
}
.log-level-warn {
  color: orange;
}
.log-level-fatal {
  color: rgb(148, 8, 8);
}
.log-level-info {
  color: black;
}
.job-state-security {
  color: yellow;
}
</style>
